module.exports = __webpack_public_path__ + "img/industry.ad0d3874.png";